module.exports = __webpack_public_path__ + "static/media/bsc.86331bc5.png";